export enum ENDPOINT {
  CONFIG = "config",
  PUBLIC_HOLIDAYS = "settings/public-holidays",
  USER_PROFILE = "UserProfile",
  JOB_EXTERNAL_API = "jobOrderExternal",
  TOOLS = "tools",
  TOOL = "tool",
  TOOL_DETAILS = "tools/get-details",
  TOOL_TAGGING = "tool-tagging/tag",
  TOOL_UNTAGGING = "tool-tagging/untag",
  JOB_ORDER_USER_ROLE = "jobOrder/userRoles",
  SESSION_STATUS = "session/status",
  NOTIFICATIONS_ME = "notifications/me/lightweight",
  NOTIFICATIONS_ME_TOTAL_UNREAD = "notifications/me/total-unread",
  NOTIFICATION_READ = "notification",
  NOTIFICATIONS_MARK_ALL_READ = "notifications/mark-all-read",
  USER_PAGED = "user/paged",
}
